import { render, staticRenderFns } from "./Workspace.vue?vue&type=template&id=d20d6cdc&scoped=true&"
import script from "./Workspace.vue?vue&type=script&lang=js&"
export * from "./Workspace.vue?vue&type=script&lang=js&"
import style0 from "./Workspace.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Workspace.vue?vue&type=style&index=1&id=d20d6cdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20d6cdc",
  null
  
)

export default component.exports